import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ArrowDirection } from '../ui-arrow-button/ui-arrow-button';
import style from './ui-chevron-arrow-icon.css?inline';
import '../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-chevron-arrow-icon';

@customElement(CName)
export class UIChevronArrowIcon extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) arrowDirection: ArrowDirection = ArrowDirection.RIGHT;
  @property({ type: String }) class = '';

  render() {
    return html`
      <ui-sprite-svg class="chevron-arrow ${this.class} ${this.arrowDirection}" .iconID=${'chevron-arrow-icon'}></ui-sprite-svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIChevronArrowIcon;
  }
}
